import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({providedIn:'root'})
export class ServersService{
    constructor(private httpClient: HttpClient){}

    getFreeServer(token: string): Observable<{ canOrderFree: boolean; activeFreeCount: number }> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        });
        return this.httpClient.get<{ canOrderFree: boolean; activeFreeCount: number }>(
            `${environment.creatoradminApi}se2/user/subscriptions/free-eligibility`,
            { headers }
        );
    }
}